import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ObjectIdModule} from '../../modules/models'
import {TermsModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function deleteTermsService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<TermsModel>>(`${BASEURL}/terms/deleteTerms`, {
    data: dto,
  })
}
